import React from "react";

function Adminfooter() {
  return (
    <>
      <footer class="footer" style={{ padding: "15px 2.45rem" }}>
        <div class="d-sm-flex justify-content-center justify-content-sm-between">
          <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">
            Copyright &copy; JAC. All rights reserved.
          </span>
        </div>
      </footer>
    </>
  );
}

export default Adminfooter;
